// Default namespace (UI translations)
import defaultEn from './locales/default/en';
import defaultEs from './locales/default/es';
import defaultFr from './locales/default/fr';
import defaultIt from './locales/default/it';
import defaultPt from './locales/default/pt';
import defaultDe from './locales/default/de';

// Domain namespace (business logic translations)
import domainEn from './locales/domain/en';
import domainEs from './locales/domain/es';
import domainFr from './locales/domain/fr';
import domainIt from './locales/domain/it';
import domainPt from './locales/domain/pt';
import domainDe from './locales/domain/de';

export default {
  en: {
    default: defaultEn,
    domain: domainEn,
  },
  es: {
    default: defaultEs,
    domain: domainEs,
  },
  fr: {
    default: defaultFr,
    domain: domainFr,
  },
  it: {
    default: defaultIt,
    domain: domainIt,
  },
  pt: {
    default: defaultPt,
    domain: domainPt,
  },
  de: {
    default: defaultDe,
    domain: domainDe,
  },
};
